/**
 * 應用路由常數
 * 集中管理所有路由路徑，便於維護和重用
 */

export const ROUTES = {
  // 主要頁面
  HOME: "/",
  LOGIN: "/login",
  PROFILE: "/profile",

  // 法律相關頁面
  TERMS: "/terms",
  PRIVACY: "/privacy",

  LIST: "/list",
  CONVERSATION: "/conversation",

  // 功能頁面
  DASHBOARD: "/dashboard",
  CHAT_BUILDING: "/chat-building",

  // 活動和通知
  ACTIVITY: "/activity",
  NOTIFICATIONS: "/notifications",

  // 網站管理
  WEBSITE: "/website",
  WEBSITE_PAGES: "/website/pages",
  WEBSITE_TEMPLATES: "/website/templates",
  WEBSITE_DOMAINS: "/website/domains",

  // SEO 相關
  SEO: "/seo",
  SEO_KEYWORDS: "/seo/keywords",
  SEO_PERFORMANCE: "/seo/performance",

  // 資源管理
  RESOURCES: "/resources",
  RESOURCES_MEDIA: "/resources/media",
  RESOURCES_DOCUMENTS: "/resources/documents",
  RESOURCES_UPLOADS: "/resources/uploads",

  // 數據分析
  ANALYTICS: "/analytics",
  ANALYTICS_TRAFFIC: "/analytics/traffic",
  ANALYTICS_CONVERSION: "/analytics/conversion",

  // 行銷管理
  MARKETING: "/marketing",
  MARKETING_CAMPAIGNS: "/marketing/campaigns",
  MARKETING_EMAIL: "/marketing/email",
  MARKETING_SOCIAL: "/marketing/social",

  // 專案管理
  PROJECTS: "/projects",
  PROJECTS_LIST: "/projects/list",
  PROJECTS_TEMPLATES: "/projects/templates",
  PROJECT_DETAIL: (id: string) => `/projects/${id}`,

  // 設定相關
  SETTINGS: "/settings",
  SETTINGS_ACCOUNT: "/settings/account",
  SETTINGS_BILLING: "/settings/billing",
  SETTINGS_TEAM: "/settings/team",

  // 測試頁面
  TEST_CONTEXT: "/test-context",

  // 錯誤頁面
  NOT_FOUND: "/404",
  PERMISSION_DENIED: "/403",
};
